export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_quotedSampleSpec') || 'Size',
    field: 'quotedSampleSpec',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 200,
        placeholder: that.$l('form_placeholder_quotedSampleSpec') || '请输入报价产品尺寸',
        clearable: true,
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_quotedCasePack') || 'Case Pack',
    field: 'quotedCasePack',
    align: 'center',
    width: 130,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder:
          that.$l('form_placeholder_quotedCasePack') || '请输入装箱入数',
        min: 0,
        max: 1000000000,
        step: 1,
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_quotedMoq') || 'MOQ',
    field: 'quotedMoq',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 200,
        placeholder: that.$l('form_placeholder_quotedMoq') || '请输入报价起订量',
        clearable: true,
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('item_label_quotedPrice') || 'Price',
    field: 'quotedPrice',
    align: 'center',
    width: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder:
          that.$l('form_placeholder_quotedPrice') || '请输入报价产品单价',
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
